import { useState } from 'react';
import { faqs } from '@/mocks/data';

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((faq) => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.answer,
    },
  })),
};

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="bg-background-100 py-14 md:py-20">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />
      <div className="px-4 md:px-6 lg:px-10 max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 text-center mb-3">
          常见问题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          关于<strong>韩漫网址</strong>和<strong>韩漫大全</strong>的常见疑问
        </p>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-lg overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <span className="text-sm font-medium text-foreground-900 pr-4">{faq.question}</span>
                <i className={`ri-${openIndex === idx ? 'subtract' : 'add'}-line w-5 h-5 flex-shrink-0 flex items-center justify-center text-foreground-500 transition-transform duration-300`}></i>
              </button>
              {openIndex === idx && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}